<template>
    <div class="chengepassword">
        <div class="top">
            账号管理 <Button class="title-btn" type="success" ghost @click="toindex">返回业务</Button>
        </div>
        <div class="bottom">
            <img class="heard-img" src="./img/head.png" alt="">
            <div>
                <div class="password-cont">
                    <ul class="jindu">
                        <li class="jindu-li">
                            <span class="border" :class="{'border-active':passwordisShow==true}">1</span>
                            <div class="jindu-lis" :class="{'jindu-lis-active':shenfenActive==true}"></div>
                        </li>
                        <li class="jindu-li">
                            <span class="border" :class="{'border-active':shenfenActive==true}">2</span>
                            <div class="jindu-lis" :class="{'jindu-lis-active':mimaActive==true}"></div>
                        </li>
                        <li class="jindu-li">
                            <span class="border"  :class="{'border-active':mimaActive==true}">3</span>
                        </li>
                    </ul>
                    <ul class="jindu">
                        <li class="jindu-li" :class="{'kong-active':passwordisShow==true}"><span>身份验证</span><div class="kong"></div></li>
                        <li class="jindu-li" :class="{'kong-active':shenfenActive==true}"><span>设置密码</span><div class="kongs"></div></li>
                        <li class="jindu-li" :class="{'kong-active':mimaActive==true}"><span>完成</span></span><div class="kong3"></div></li>
                    </ul>
                
                    <div class="form-cont" v-show="passwordisShow && !shenfenActive">
                        <div class="form-left">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130">
                                <FormItem label="姓名："  prop="name" class="bumenModal-item">
                                    <Input clearable disabled v-model="formValidate.name" class="input" placeholder="请输入姓名" />
                                </FormItem>
                                <FormItem label="手机号："  prop="phone" class="bumenModal-item">
                                    <Input clearable disabled v-model="formValidate.phone" class="input" placeholder="请输入手机号" />
                                </FormItem>
                                <FormItem label="验证码：" prop="yanma" class="bumenModal-item">
                                    <Input clearable v-model="formValidate.yanma" class="input" placeholder="请输入验证码" />
                                </FormItem>
                            </Form>
                            
                        </div>
                        <div class="form-right">
                            <Button class="btn fiveSize" type="success" ghost  @click="yanzhengma">获取验证码</Button>
                            <Button class="btn margin" type="success" ghost @click="yanzhengma()" v-show="!isbtn"><span v-show="btnNum!==0">{{btnNum}}</span> 重新获取</Button>
                        </div>
                    </div>
                <!--  --> 
                    <div class="form-cont form-conts" v-show="shenfenActive && !mimaActive">
                        <Form ref="passworddate" :model="passworddate" :rules="rulepassdate" :label-width="130">
                            <FormItem label="新密码：" :readonly="readonly" prop="pass" class="bumenModal-item">
                                <Input clearable @click.native="aaa(1)" v-model="passworddate.pass" name="password" type="password" class="input" placeholder="请输入密码" />
                            </FormItem>
                            <FormItem label="确认新密码：" :readonly="readonly2" prop="newpass" class="bumenModal-item">
                                <Input clearable @click.native="aaa(2)" v-model="passworddate.newpass" name="password" type="password" class="input" placeholder="请输入密码" />
                            </FormItem>
                        </Form>
                    </div>
                    <div class="form-cont form-sucesses" v-show="mimaActive">
                        <Icon style="font-size:20px;vertical-align:bottom;" type="md-checkmark-circle" />密码修改成功
                    </div>
                    <div style="clear:both"></div>
                    <div class="errorTile" v-show="issure">{{errorTitle}}</div>
                </div>
                
            <!--   -->
                <div class="secondBumen-bottom" v-show="passwordisShow && !shenfenActive">
                    <Button class="btn" type="success" ghost  @click="handleReset1('formValidate')">取消</Button>
                    <Button class="btn sure" type="success" ghost  @click="handleSubmit1('formValidate')">确定</Button>
                </div>
                <div class="secondBumen-bottom" v-show="shenfenActive && !mimaActive">
                    <Button class="btn" type="success" ghost  @click="handleReset2('addnameobj')">上一步</Button>
                    <Button class="btn sure" type="success" ghost  @click="handleSubmit2('passworddate')">确定</Button>
                </div>

            </div>


        </div>
        <!-- <Spin fix v-show="isiconfontshow">
            <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
            <div>距离有些遥远，小简 正在努力中……</div>
        </Spin> -->
    </div>
</template>
<script>
    import {
        sendSmsPwdCode,
        checkSmsPwdCode,
        resetPassword
    } from './servers/api'
    export default {
        name: 'chengepassword',
        data() {
            return {
                readonly2: true,
                readonly: true,
                isiconfontshow: false,
                formValidate: {
                    phone: '',
                    name: '',
                    yanma: ''
                },
                UUID: '',
                errorTitle: '请输入正确的验证码', //'请将确认新密码与新密码的内容保持一致'
                isbtn: true,
                issure: false,
                ishowtitle: false,
                title: '用户名或密码不正确', //请填写用户名 请填写登录密码
                passwordisShow: true, //忘记密码点击
                shenfenActive: false, //身份验证通过
                mimaActive: false, //设置密码通过
                passworddate: {
                    pass: '',
                    newpass: ''
                },
                btnNum: 0,
                btntitle: '秒后重新获取', //获取按钮文字
                rulepassdate: {
                    pass: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    newpass: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }]
                },
                ruleValidate: {
                    name: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }],
                    yanma: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }],
                }, //必填校验
                login: {}
            }
        },
        created() {

        },
        methods: {
            aaa(index) { //更改只读状态
                if (index == 1) {
                    this.readonly = false;
                } else {
                    this.readonly2 = false;
                }
            },
            handleReset1(name) { //取消
                this.$emit("changpasswordeishow", false)
            },
            yanzhengma(index) { //点击获取验证码
                if (this.btnNum == 0 && this.formValidate.phone !== '') {
                    this.issure = false;
                    let params = {
                        phone: Number(this.formValidate.phone)
                    }
                    sendSmsPwdCode(params).then(res => {
                        if (res.data.code == 1) {
                            this.UUID = res.data.data.UUID;
                            this.issure = false;
                            this.btnNum = 60;
                            this.isbtn = false;
                            let timer = setInterval(() => {
                                this.btnNum--
                                    if (this.btnNum <= 0) {
                                        this.btnNum = 0;
                                        clearInterval(timer)
                                        timer = null;
                                        setTimeout(() => {
                                            this.isbtn = true;
                                        }, 1000)
                                    }
                            }, 1000);
                        } else {
                            this.issure = true;
                            this.errorTitle = res.data.msg;
                        }
                    })
                } else if (this.formValidate.phone == '') {
                    this.errorTitle = '请输入手机号';
                    this.issure = true;
                }


            },
            handleSubmit1(name) { //确定
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let params = {
                            code: this.formValidate.yanma,
                            phone: this.formValidate.phone,
                            UUID: this.UUID
                        }
                        checkSmsPwdCode(params).then(res => {
                            if (res.data.code == 1) {
                                this.issure = false;
                                this.shenfenActive = true;
                            } else {
                                this.errorTitle = '请输入正确的验证码';
                                this.issure = true;
                            }
                        })
                    }
                })
            },
            handleReset2() {
                this.shenfenActive = false;
            },
            handleSubmit2(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.passworddate.newpass !== this.passworddate.pass) {
                            this.errorTitle = '请将确认新密码与新密码的内容保持一致';
                            this.issure = true;
                        } else {
                            this.issure = false;
                            let params = {
                                phone: this.formValidate.phone,
                                password1: this.passworddate.pass,
                                password2: this.passworddate.newpass

                            }
                            resetPassword(params).then(res => {
                                if (res.data.code == 1) {
                                    this.mimaActive = true;
                                }
                            })
                        }
                    } else {
                        this.issure = false;
                    }
                })
            },
            gopass(num) { //点击账号管理进来 回复默认值
                if (sessionStorage.getItem('login')) {
                    this.login = JSON.parse(sessionStorage.getItem('login'))
                    this.formValidate.name = this.login.userName;
                    this.formValidate.phone = this.login.phone;
                }

                this.formValidate.yanma = ''
                this.isiconfontshow = false;
                this.errorTitle = '请输入正确的验证码' //'请将确认新密码与新密码的内容保持一致'
                this.isbtn = true
                this.issure = false
                this.ishowtitle = false
                this.shenfenActive = false //身份验证通过
                this.mimaActive = false //设置密码通过
            },
            toindex() {
                this.$emit("changpasswordeishow", false)
            },
        }
    }
</script>
<style lang="scss" scoped="" type="text/css">
    @import "./css/conmmon.scss";
    @import "./font/iconfont.css";
    .errorTile {
        width: 100%;
        text-align: center;
        color: #F59A23;
        position: absolute;
        bottom: 0px;
        left: -55px;
        height: 20px;
    }
    
    .chengepassword {
        font-family: SimHei;
        padding: 30px;
        font-size: 13px;
        color: #7F7F7F;
        .top {
            font-size: 16px;
            padding: 15px;
            border-bottom: 1px dashed #53CAC3;
            .title-btn {
                margin-left: 15px;
                line-height: 15px;
                float: right;
            }
        }
        .title-btns {
            margin-left: 575px;
        }
        .bottom {
            width: 100%;
            // padding:30px 0 40px 250px;
            padding-top: 15px;
            text-align: center;
            .heard-img {
                width: 150px;
                height: 150px;
            }
        }
    }
    
    .password-cont {
        color: #7F7F7F;
        position: relative;
        width: 600px;
        margin-top: 25px;
        padding-bottom: 25px;
        margin: 15px auto;
        text-align: center;
        margin-bottom: 0;
        .jindu {
            display: inline-block;
            .jindu-li {
                display: inline-block;
                float: left;
                .border {
                    width: 30px;
                    height: 30px;
                    display: inline-block;
                    border: 2px solid #D7D7D7;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 29px;
                    color: #D7D7D7;
                }
                .border-active {
                    color: #53CAC3;
                    border-color: #53CAC3;
                }
            }
            .jindu-lis {
                display: inline-block;
                width: 130px;
                height: 5px;
                background: #D7D7D7;
                vertical-align: middle;
            }
            .jindu-lis-active {
                background: #53CAC3;
            }
            .kong,
            .kongs,
            .kong3 {
                display: inline-block;
                width: 115px;
            }
            .kongs {
                width: 128px;
            }
            .kong3 {
                width: 10px;
            }
            .kong-active {
                color: #53CAC3;
            }
        }
        .bumenModal-item {
            margin-bottom: 20px;
        }
    }
    
    .form-cont {
        width: 100%;
        margin-top: 15px;
        .form-left {
            width: 450px;
            float: left;
        }
        .form-right {
            float: right;
            text-align: left;
            width: 120px;
            padding-top: 57px;
            .margin {
                width: 120px;
                margin-top: 27px;
            }
        }
    }
    
    .form-conts {
        padding-right: 45px;
    }
    
    .form-sucesses {
        color: #53CAC3;
    }
</style>


// WEBPACK FOOTER //
// src/components/changePassword.vue